import React from 'react';
import { motion } from 'framer-motion';
import { TreePine, ArrowRight } from 'lucide-react';

export default function BiodiversityFinance() {
  return (
    <div className="pt-16">
      <section className="relative py-20 bg-gradient-to-br from-green-900 to-green-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center"
          >
            <h1 className="text-4xl font-bold text-white mb-6">
              Nature and Biodiversity Finance
            </h1>
            <p className="text-xl text-green-100 max-w-3xl mx-auto">
              Developing financial solutions for preserving and enhancing natural ecosystems
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Approach</h2>
              <p className="text-gray-600 mb-8">
                We specialize in developing innovative financial mechanisms to support biodiversity 
                conservation and ecosystem restoration across Africa.
              </p>
              <ul className="space-y-4">
                {[
                  'Biodiversity offset mechanisms',
                  'Conservation finance strategies',
                  'Natural capital investment',
                  'Ecosystem services valuation',
                  'Sustainable land use financing'
                ].map((item) => (
                  <li key={item} className="flex items-start">
                    <ArrowRight className="h-5 w-5 text-green-600 mr-2 mt-1" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="relative rounded-xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1511497584788-876760111969?ixlib=rb-1.2.1&auto=format&fit=crop&w=2850&q=80"
                alt="Biodiversity Finance"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}